import {useEffect} from 'react';
import {handleImageOrVideoUpload, onUploadImageAndVideo} from '@Libraries/record-image-and-video.library';
import {RecorderMediaType} from '@Panels/record-image-and-video-panel/record-image-and-video.types';
import type {ElementData} from '@Libraries/add-media-library';
import type {UserMediaType, UserMediaVOResponse} from '@Libraries/user-media-library';

interface UseHiddenImageAndVideoInputOptions {
  handleHiddenInputTagClick: (mediaType: RecorderMediaType, onClose?: () => void, withCapture?: boolean) => void;
}

export function useHiddenImageAndVideoInput(onAddRecordedItem: (item: ElementData) => void): UseHiddenImageAndVideoInputOptions {
  useEffect(() => {
    return () => {
      const tempInput = document.querySelector('.js-temp-input') as HTMLInputElement;
      if (tempInput) {
        document.body.removeChild(tempInput);
      }
    };
  }, []);

  const onUpload = (type: UserMediaType, data: Array<UserMediaVOResponse> | UserMediaVOResponse): void => {
    onUploadImageAndVideo(type, data, (item: ElementData) => {
      onAddRecordedItem(item);
    });
  };

  const handleHiddenInputTagClick = (mediaType: RecorderMediaType, onClose?: () => void, withCapture = true): void => {
    const possiblePreviousTempInput = document.querySelector('.js-temp-input') as HTMLInputElement;
    if (possiblePreviousTempInput) {
      document.body.removeChild(possiblePreviousTempInput);
    }

    let tempInput = document.querySelector('.js-temp-input') as HTMLInputElement;
    if (!tempInput) {
      tempInput = document.createElement('input');
      tempInput.type = 'file';
      tempInput.accept = mediaType === RecorderMediaType.IMAGE ? 'image/*' : 'video/*';
      if (withCapture) {
        tempInput.capture = 'true';
      }
      tempInput.className = 'js-temp-input';

      document.body.appendChild(tempInput);

      tempInput.addEventListener('change', () => {
        if (tempInput.files) {
          handleImageOrVideoUpload({fileToUpload: tempInput.files[0], mediaType}, onUpload);
          if (onClose) {
            onClose();
          }

          document.body.removeChild(tempInput);
        }
      });
    }

    tempInput.click();
  };

  return {handleHiddenInputTagClick};
}
